import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import './style.scss';

// HRS stands for High Risk Supplements
const HRSListEmptyCard: FC = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Box className="hrs-list-blank-card__section">
      <Box className="hrs-list-blank-card__icon">
        <Box component="img" src="/images/img-clipboard.svg" />
      </Box>

      <Box className="hrs-list-blank-card__description">
        <p className="subtitle-big">{t('highRiskSupplements.emptyCardNotification')}</p>
      </Box>
    </Box>
  );
};

export default HRSListEmptyCard;
